import { Modal } from 'react-bootstrap';

function Spinner() {
  return (
    <div className="submitStatus__spinner" aria-hidden="true">
      {Array.from({ length: 12 }, (_, index) => (
        <span key={index} style={{ '--i': index }} />
      ))}
    </div>
  );
}

function CheckMark() {
  return (
    <svg className="submitStatus__check" viewBox="0 0 120 120" aria-hidden="true">
      <circle cx="60" cy="60" r="60" fill="currentColor" />
      <path
        d="M34 63L51 80L88 40"
        fill="none"
        stroke="#000"
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SubmitStatusModal({ phase }) {
  const submitted = phase === 'submitted';

  return (
    <Modal
      show={phase === 'submitting' || submitted}
      onHide={() => {}}
      backdrop="static"
      keyboard={false}
      centered
      className="submitStatusModal"
      aria-labelledby="submit-status-title"
    >
      <Modal.Body>
        {submitted ? <CheckMark /> : <Spinner />}
        <h2 id="submit-status-title" className="submitStatus__title">
          {submitted ? (
            <>
              Your entry
              <br />
              has been submitted
              <br />
              successfully!
            </>
          ) : (
            'Submitting your entry'
          )}
        </h2>
      </Modal.Body>
    </Modal>
  );
}

export default SubmitStatusModal;
